import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import orangePaintingBrush from '../../../images/orangePaintingBrush.svg';
import { setValues } from '../../Actions/Configurator.action';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';

const PanelBlasting = () => {
  const dispatch = useDispatch(),
    configurator = useSelector((state) => state.configurator),
    { id, rules, selections } = configurator;

  const updateSetting = (values) => {
    dispatch(setValues(values));
  };

  const [toggle, setToggle] = useState(false);

  const setBlastingColorCode = (colorCode, name) => {
    if (colorCode == -1) {
      updateSetting({ blastingDetails: { colorCode: colorCode, }, });

      googleAnalyticsProductConfigurator('blastPaintCode', ' ', id);
    }

    if (rules.colors.length > 0) {
      let color = rules.colors.filter((c) => c.colorCode == colorCode);
      if (color.length >= 1) {
        let thickness = color[0].thicknessOptions;
        updateSetting({
          blastingDetails: {
            blastPaintCode: thickness[0].blastPaintCode,
            colorCode: colorCode,
            isPainting: thickness[0].isPainting,
            name: thickness[0].isPainting ? thickness[0].name : 'Blasting',
          },
        });

        googleAnalyticsProductConfigurator('blastPaintColor', color[0].name, id);
      }
    }
  };

  const setThickness = (color, thickness) => {
    let thicknessName = (thickness.name != '' ? thickness.name : 'None');
    updateSetting({
      blastingDetails: {
        blastPaintCode: thickness.blastPaintCode,
        colorCode: color.colorCode,
        isPainting: thickness.isPainting,
        name: color.name + ' ' + thicknessName,
      },
    });

    googleAnalyticsProductConfigurator('thickness', thicknessName);
  };

  const getColorType = () => {
    return selections.blastingDetails != null && selections.blastingDetails.colorCode != null ? selections.blastingDetails.colorCode : null;
  };

  const getBlastingPaintCode = (blastPaintCode, colorCode) => {
    return selections.blastingDetails != null && selections.blastingDetails.blastPaintCode != null && selections.blastingDetails.colorCode > -1
      ? selections.blastingDetails.blastPaintCode === blastPaintCode && selections.blastingDetails.colorCode === colorCode
      : '';
  };

  const getSelectedText = () => {
    let colorType = getColorType();
    let selected = rules.colors.filter((c) => c.colorCode == colorType)[0] != null
      ? translate('blasting.' + rules.colors.filter((c) => c.colorCode == colorType)[0].name.toLowerCase().replace(/\s+/g, ''))
      : translate('blasting.none');
    let blastingSize = getSelectedBlastingSize(colorType);

    return (selected + (blastingSize ? ' ' + getSelectedBlastingSize(colorType) : ''));
  };

  const getSelectedBlastingSize = (colorType) => {
    const selectedColor = rules.colors.filter((c) => c.colorCode == colorType)[0];
    if (selectedColor != undefined || selectedColor != null) {
      const selectedBlastCode1 = (selections.blastingDetails && selections.blastingDetails.blastPaintCode) || '';
      const selectedBlastingSize = selectedColor.thicknessOptions.filter((c) => c.blastPaintCode == selectedBlastCode1)[0].name;
      return selectedBlastingSize;
    }
  };

  if (rules.allowBlasting !== true && rules.allowPainting !== true) {
    return null;
  }

  return (
    <>
      <section className='configurator-box'>
        <header>
          <img className='configurator-box__icon' src={orangePaintingBrush} />
          <h4 className='configurator-box__title'>
            {translate('blasting.title')}
          </h4>
          <details className='config-details config-details--no-padding config-details--right-align config-details--link'>
            <summary onClick={() => { setToggle(!toggle); }}>
              <span>{getSelectedText()}</span>
              <img className='config-details__icon' src='/ui/images/arrow-down.svg' />
            </summary>
          </details>
        </header>
        {toggle && (
          <div className='configurator-box__content'>
            <div className='accordion-panel__panel_content'>
              <div className='panel-blasting'>
                <div className='panel-blasting__select-blasting'>
                  {rules.allowBlasting && (
                    <div className={getColorType() == -1 ? 'panel-blasting__select-blasting__select-mode selected-blasting select-nothing' : 'panel-blasting__select-blasting__select-mode select-nothing'}
                      onClick={() => setBlastingColorCode(-1)}                    >
                      <div className='select-tick'>
                        <svg>
                          <use href='/ui/images/sprites/be-group.svg#tick-orange'></use>
                        </svg>
                      </div>
                      <div className='blasting-image'></div>
                      <div className='blasting-content'>
                        <h4>{translate('blasting.none')}</h4>
                      </div>
                    </div>
                  )}

                  {rules.allowPainting && rules.colors.length > 0 &&
                    rules.colors.map((value, index) => (
                      <div key={`model${index}`}
                        className={value.colorCode == getColorType()
                          ? `panel-blasting__select-blasting__select-mode selected-blasting select_color__${value.name.toLowerCase().replace(/\s+/g, '')}`
                          : `panel-blasting__select-blasting__select-mode select_color__${value.name.toLowerCase().replace(/\s+/g, '')}`}
                        onClick={() => setBlastingColorCode(value.colorCode, value.name)}>
                        <div className='select-tick'>
                          <svg>
                            <use href='/ui/images/sprites/be-group.svg#tick-orange'></use>
                          </svg>
                        </div>
                        <div className='blasting-image'></div>
                        <div className='blasting-content'>
                          <h4>
                            {translate('blasting.' + value.name.toLowerCase().replace(/\s+/g, ''))}
                          </h4>
                          {value.thicknessOptions.length > 1 &&
                            value.thicknessOptions.map(
                              (thickness, innerIndex) => (
                                <div className='select-value' key={`childModel${innerIndex}`}                                >
                                  <label htmlFor={`${value.name.toLowerCase().replace(/\s+/g, '')}_${thickness.blastPaintCode}_${innerIndex}`}>
                                    {thickness.name != '' ? thickness.name : 'None'}
                                    <input name='thicknes' checked={getBlastingPaintCode(thickness.blastPaintCode, value.colorCode)} type='radio'
                                      id={`${value.name.toLowerCase().replace(/\s+/g, '')}_${thickness.blastPaintCode}_${innerIndex}`}
                                      onChange={(event) => setThickness(value, thickness)} value={`${thickness.blastPaintCode}_${value.colorCode}`}
                                    ></input>
                                  </label>
                                </div>
                              )
                            )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default PanelBlasting;
